<!-- //
dialog SSH服务器表单添加
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="600px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="130px" class="form">
        <el-row class="flow-row">
          <el-form-item prop="envType" label="类型">
            <el-select
                v-model="form.envType"
                placeholder="请选择"
                clearable
                :disabled="editMode"
                style="width: 100%">
              <el-option
                  v-for="item in this.$store.getters.dictType['ENV_TYPE']"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="nodeCode" label="节点code">
            <el-input v-model="form.nodeCode" clearable :disabled="editMode"/>
          </el-form-item>
          <el-form-item prop="nodeName" label="节点名称">
            <el-input v-model="form.nodeName" clearable/>
          </el-form-item>
          <el-form-item prop="ip" label="IP地址">
            <el-input v-model="form.ip" clearable/>
          </el-form-item>
          <el-form-item prop="port" label="端口">
            <el-input v-model="form.port" clearable/>
          </el-form-item>
          <el-form-item prop="username" label="账号">
            <el-input v-model="form.username" clearable/>
          </el-form-item>
          <el-form-item prop="password" label="密码">
            <el-input v-model="form.password" clearable>
              <el-button slot="append" @click="handleEncrypt">加密</el-button>
            </el-input>
          </el-form-item>
          <el-form-item prop="rootPath" label="根路径">
            <el-input v-model="form.rootPath" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="maxTotal" label="最大连接数">
            <el-input v-model="form.maxTotal" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="maxIdle" label="最大空闲连接数">
            <el-input v-model="form.maxIdle" clearable/>
          </el-form-item>
          <el-form-item prop="minIdle" label="最小空闲连接数">
            <el-input v-model="form.minIdle" clearable></el-input>
          </el-form-item>
          <el-form-item prop="status" label="状态">
            <el-radio-group v-model="form.status">
              <el-radio-button label="1">上线</el-radio-button>
              <el-radio-button label="0">下线</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button size="small" type="primary" @click="handleValidate" :loading="validateLoading">测 试</el-button>
      <el-button size="small" type="primary" @click="handleOk" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import RemoteSshApi from '@/api/sys/sysRemoteSsh.api.js';
import DatasourceApi from '@/api/datasvc/datasource.api.js';
const FORM_DEFINE = {
  envType: null,
  nodeCode: null,
  nodeName: null,
  ip: null,
  port: 22,
  username: null,
  password: null,
  rootPath: null,
  maxTotal: null,
  maxIdle: null,
  minIdle: null,
  status: 1,
};
export default {
  name: 'ViewRemoteSshDetail',
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: String},
    {dictType: 'ENV_TYPE', dataType: String},
  ],
  data() {
    return {
      loading: false,
      validateLoading: false,
      visible: false,
      title: '新建服务器',
      opts: {
        mode: null,
      },
      form: this.$util.mergeObject(FORM_DEFINE),
      rules: {
        envType: [{required: true, message: "请选择环境", trigger: 'change'}],
        nodeCode: [{required: true, message: "请输入code", trigger: 'blur'}],
        nodeName: [{required: true, message: "请输入名称", trigger: 'blur'}],
        ip: [{required: true, message: "请输入IP地址", trigger: 'blur'}],
        port: [{required: true, message: "请输入端口号", trigger: 'blur'}],
      },
    }
  },
  computed: {
    editMode() {
      return this.opts.mode === 2;
    }
  },
  methods: {
    showModal({data, mode, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        mode: mode,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      console.log("===========>", opts)
      this.visible = true;
      this.opts.mode = opts.mode
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(FORM_DEFINE,  opts.data)
      this.form = opts.data
      this.title = opts.title
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 加密
     */
    handleEncrypt() {
      DatasourceApi.encrypt(encodeURIComponent(this.form.password)).then(resp => {
        this.form.password = resp.data;
      })
    },

    /**
     * 测试连通性
     */
    handleValidate() {
      this.validateLoading = true;
      RemoteSshApi.validateConn(this.form).then(resp => {
        this.validateLoading = false;
        if(resp.data) {
          this.$modal.msgSuccess("连接成功")
        } else {
          this.$modal.msgError("连接失败")
        }
      }).catch(err => {
        this.validateLoading = false;
      })
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return RemoteSshApi.saveSsh(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 50px;
}
</style>
